import { render } from "./ComparativeTVPLowVariance.vue?vue&type=template&id=35a93910"
import script from "./ComparativeTVPLowVariance.vue?vue&type=script&lang=js"
export * from "./ComparativeTVPLowVariance.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__